import { call, delay, fork, put, select } from 'redux-saga/effects';
import { photoCaptureIntelligentDamageDetectionFailureAction, photoCaptureIntelligentDamageDetectionGetSuccessAction, photoCaptureIntelligentUpdateIterationDamageCallStatusAction } from '../actions';
import { IntelligentAssignmentSummary, SERVICE_FAIL_STATUS } from '../constants';
import { IntelligentPhotoCaptureAttachmentIterationStatus } from '../enums';
import { getErrorMessagesBasedOnStatusCode, isValidDamageDetectionResponse } from '../utilities';
import { PhotoCaptureIntelligentDamageDetectionService } from '../services';
import { getPhotoCaptureClaimNumber } from '../selectors';
import { intelligentPhotoCaptureFailureLoggingSaga } from './intelligentPhotoCaptureFailureLoggingSaga';
export function* photoCaptureIntelligentDamageDetectionGetSaga(action) {
    const claimNumber = yield select(getPhotoCaptureClaimNumber);
    try {
        const damageDetectionService = new PhotoCaptureIntelligentDamageDetectionService();
        const { companyCode, requestId, instanceReferenceId, isPolling, iterationId } = action.payload;
        // Only execute polling loop if isPolling is true
        if (isPolling) {
            for (let attempt = 1; attempt <= IntelligentAssignmentSummary.DAMAGE_MAX_RETRY_COUNT; attempt += 1) {
                const response = yield call([damageDetectionService, damageDetectionService.getDamageDetection], companyCode, requestId, instanceReferenceId, claimNumber);
                if (isValidDamageDetectionResponse(response)) {
                    yield put(photoCaptureIntelligentDamageDetectionGetSuccessAction(response, iterationId));
                    return;
                }
                if (attempt < IntelligentAssignmentSummary.DAMAGE_MAX_RETRY_COUNT) {
                    yield delay(IntelligentAssignmentSummary.POLL_INTERVAL_TO_CALL_DAMAGE_MS);
                }
            }
        }
        else {
            const response = yield call([damageDetectionService, damageDetectionService.getDamageDetection], companyCode, requestId, instanceReferenceId, claimNumber);
            if (isValidDamageDetectionResponse(response)) {
                yield put(photoCaptureIntelligentDamageDetectionGetSuccessAction(response, iterationId));
                return;
            }
        }
        if (typeof iterationId === 'number' && Number.isFinite(iterationId)) {
            yield put(photoCaptureIntelligentUpdateIterationDamageCallStatusAction(iterationId, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED));
        }
        yield put(photoCaptureIntelligentDamageDetectionFailureAction(SERVICE_FAIL_STATUS));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        // Fire-and-forget error logging so catch-path handling is not blocked.
        yield fork(intelligentPhotoCaptureFailureLoggingSaga, {
            actionType: action.type,
            response: error,
            requestedPayload: action.payload,
            claimNumber,
            companyCode: action.payload.companyCode,
            instanceReferenceId: action.payload.instanceReferenceId,
            errorDetail: errorMessage
        });
        const { iterationId } = action.payload;
        // Finalize damageCallStatus on unexpected error to unblock the pending iteration queue
        if (typeof iterationId === 'number' && Number.isFinite(iterationId)) {
            yield put(photoCaptureIntelligentUpdateIterationDamageCallStatusAction(iterationId, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED));
        }
        yield put(photoCaptureIntelligentDamageDetectionFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureDamageDetectionGetSaga.js.map